import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { waitForAuthInit } from './wait-for-auth-init';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Aguarda a inicialização do auth de forma reativa (sem janela de corrida)
  await waitForAuthInit(authService);

  // Verificação simples - só autenticação
  if (!authService.isAuthenticated()) {
    return router.parseUrl('/login');
  }

  return true;
};
